import React from 'react';

import Modal from "@mui/material/Modal";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';


const ModalElement = props => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: props.modalWidth || 400,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '4px',
        minHeight: props.modalHeight || 200
    };

    return (
        <Modal
            open={props.modalOpen}
            onClose={props.handleClose}

        >
            <Box sx={style}>
                {/* <IconButton onClick={props.handleClose} sx={{ position: 'absolute', top: '1%', left: '90%' }}> */}
                {props.noClose ?
                    null
                    :
                    <IconButton onClick={props.handleClose} sx={{ position: 'absolute', top: 8, right: 8 }}>
                        <CloseIcon />
                    </IconButton>
                }
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {props.header}
                </Typography>
                <Typography sx={{ fontSize: 14, mb: 2 }} color="text.secondary">
                    {props.instruction}
                </Typography>
                {props.content}
            </Box>
        </Modal>
    )
}

export default ModalElement